import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import useApi from "common/ApiMiddlewere"
import { dateFormat } from "pages/Common"
import { toast } from "react-hot-toast"
import TableList from "common/TableList"

const TaskArchiveDetails = ({ id }) => {
  const { getApi } = useApi()
  const [followData, setfollowData] = useState([])
  const [isLoading, setisLoading] = useState(false)

  useEffect(() => {
    setisLoading(true)
    getApi(`Task/view-ArchiveDetails?id=${id}`).then(({ data, status }) => {
      setisLoading(false)
      if (status === 200) {
        setfollowData(data)
      } else {
        toast.error(data, {
          style: {
            fontSize: "15px",
          },
        })
      }
    })
  }, [])

  const columns = useMemo(
    () => [
      {
        Header: "Date",
        accessor: "Date",
        // Cell: ({ row }) => (
        //   <p className=" mb-0">{row.original.date.split("T")[0]}</p>
        // ),
        Cell: ({ row }) => (
          <p className=" mb-0">
            {row.original.Date == "0001-01-01T00:00:00"
              ? "N/A"
              : dateFormat(row.original.Date.split("T")[0], "dd-MM-yyyy")}
          </p>
        ),
      },
      {
        Header: "Number Achieved",
        accessor: "NumberAchieved",
        width: "10%",
      },
      {
        Header: "Amount Achieved",
        accessor: "AmountAchieved",
        width: "10%",
        Cell: ({ row }) => {
          return (
            <>
              <div style={{
                display: "flex",
                alignItems: "end",
                justifyContent: "end",
                textAlign: "end"
              }}>
                <i className="mdi mdi-currency-inr"></i>
                {`${new Intl.NumberFormat('en-IN', {
                  currency: 'INR',
                  minimumFractionDigits: 2,
                }).format(row.original?.AmountAchieved || 0)}`}</div>
            </>
          )
        },
      },
      {
        Header: "Remark",
        accessor: "Remark",
        Cell: ({ row }) => {
          return (
            <>
              <div style={{ textWrap: "wrap" }}>
                {row.original.Remark}
              </div>
            </>
          )
        },
      },
    ],
    [followData]
  )

  return (
    <>
      <TableList
        isLoading={isLoading}
        columns={columns}
        data={followData}
        isGlobalFilter={true}
        isCategoryList={true}
        customPageSize={10}
        className="custom-header-css"
      />
    </>
  )
}

TaskArchiveDetails.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default TaskArchiveDetails
